<!--  -->
<template>
    <div class="title-box">
       <h1 class="chinese-title">{{chineseTitle}}</h1>
       <h2 class="en-title">{{enTitle}}</h2>
       <h3 class="line"></h3>
    </div>
  </template>
  
  <script>
  export default {
    name: '',
    data () {
      return {
      }
    },
  
    props: ["chineseTitle", "enTitle"],
  
    watch: {},
  
    components: {},
  
    computed: {},
  
    created () {},
  
    methods: {}
  }
  
  </script>
  <style lang='scss' scoped>
  .title-box {
     text-align: left;
    .chinese-title {
      // color: #333;
      // font-size: 28px;
      // line-height: 40px;
      // font-weight: bold;
      font-size: 44px;
      font-weight: 900;
      color: #222222;
      line-height: 59px;
    }
    .en-title {
      font-size: 22px;
      color: #222222;
      line-height: 40px;
      letter-spacing: 1px;
    }
    .line{
      width: 100px;
      height: 2px;
      background: #222222;
      margin-top: 14px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/header/processTitle.vue